<template>
  <a-modal title="项目报名" :visible="visible" :confirmLoading="confirmLoading" width="660px" @ok="handleOk"
    @cancel="handleCancel" :bodyStyle="{ padding: '24px' }">
    <div class="signup-content">
      <!-- Left Column: Registration Info -->
      <div class="info-section">
        <div class="info-row">
          <span class="label">报名信息：</span>
          <div class="value-group">
            <div class="company">{{ userInfo.name || "--" }}</div>
            <div class="detail">
              联系人：{{ userInfo.contactName || "--" }}
            </div>
            <div class="detail">联系电话：{{ userInfo.phone || "--" }}</div>
            <div class="detail">邮箱：{{ userInfo.email || "--" }}</div>
          </div>
        </div>
        <div class="info-row" style="margin-top: 20px; align-items: flex-start">
          <span class="label">报名材料：</span>
          <div class="value-group">
            <upload-file v-model="form.files" :max-count="5" />
            <div class="material-tip">提示：授权代表和联系人须为同一人</div>
          </div>
        </div>
      </div>

      <!-- Right Column: Payment Info -->
      <div class="payment-section">
        <img src="@/assets/qr-code.png" alt="">
        <div class="payment-remark">
          付款时请备注“
          <span>{{ userInfo.name || '公司名' }}-{{ projectCode || '项目编号' }}</span>“
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
import { postAddProjectSupplier } from "@/api/supplier";

export default {
  name: "SignupModal",
  components: { UploadFile },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: String,
      required: true
    },
    projectCode: {
      type: String,
      default: ''
    },
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        files: []
      }
    };
  },
  methods: {
    handleCancel() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },
    handleOk() {
      //   if (!this.form.files || this.form.files.length === 0) {
      //     this.$message.warning("请上传报名材料");
      //     return;
      //   }

      this.confirmLoading = true;
      let files = []
      if (this.form.files && this.form.files.length > 0) {
        files = this.form.files.map((f) => ({
          id: f.id,
          fileName: f.fileName
        }));
      } else {
        files = []
      }
      const payload = {
        projectId: this.projectId,
        file: files,
      };

      postAddProjectSupplier(payload)
        .then((res) => {
          this.$message.success("报名成功");
          this.$emit("success");
          this.$emit("update:visible", false);
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.files = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.signup-content {
  display: flex;
  justify-content: space-between;
}

.info-section {
  flex: 1;
  padding-right: 20px;
  // border-right: 1px solid #e8e8e8;
}

.payment-section {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   padding-left: 20px;
  //   border-left: 1px solid #eee;
  margin-right: 50px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;

  .label {
    width: 80px;
    text-align: right;
    color: #333;
    font-size: 14px;
    line-height: 1.5;
  }

  .value-group {
    flex: 1;

    .company {
      font-size: 14px;
      color: #333;
      margin-bottom: 5px;
    }

    .detail {
      font-size: 14px;
      color: #666;
      line-height: 1.8;
    }
  }
}

.material-tip {
  margin-top: 8px;
  color: #f5222d;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
}

/* Payment Section Styles */
.payment-header {
  background-color: #e65100;
  /* Orange/Red */
  color: white;
  padding: 8px 30px;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.payment-brand {
  color: #722ed1;
  /* Purple */
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 500;
}

.qr-code-container {
  margin-bottom: 10px;

  img {
    width: 140px;
    height: 140px;
    display: block;
  }
}

.payment-icons {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;

  .pay-icon {
    font-size: 24px;

    &.wechat {
      color: #09bb07;
    }

    &.alipay {
      color: #108ee9;
    }
  }

  .pay-icon-text {
    font-size: 12px;
    background: #d93025;
    color: white;
    padding: 2px 4px;
    border-radius: 2px;
  }
}

.payment-note {
  font-size: 12px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
  padding: 2px 10px;
}

.payment-remark {
  font-size: 12px;
  text-align: center;
  line-height: 1.5;
  width: 100%;
  word-break: break-all;
  margin-top: 10px;
  font-size: 13px;

  >span {
    color: #5772C3;
  }
}
</style>
